import { FLAGS, useFlag } from '@iheartjane/feature-flags';
import { useMemo } from 'react';

import {
  useGetSelectedOrg,
  useManager,
} from '@jane/business-admin/data-access';

export const useRetailOrgSettings = () => {
  const { data: managerData, isFetched } = useManager();
  const retailOrgEnabled = useFlag(FLAGS.cnRetailOrgUi);
  const { data: selectedOrg } = useGetSelectedOrg();

  const { enabled, org_id, query_enabled } = useMemo(
    // eslint-disable-next-line react-hooks/preserve-manual-memoization
    () => {
      const isInternal = managerData?.manager?.internal;

      // Flag is on and user is internal
      if (retailOrgEnabled && isFetched && isInternal) {
        // User has selected org using modal
        if (selectedOrg?.id) {
          return {
            enabled: true,
            org_id: selectedOrg.id,
            query_enabled: true,
          };
        }
        return {
          enabled: true,
          org_id: undefined,
          query_enabled: true,
        };
      }

      return {
        enabled: false,
        org_id: undefined,
        query_enabled: true,
      };
    },
    [
      retailOrgEnabled,
      isFetched,
      managerData?.manager?.internal,
      selectedOrg?.id,
    ]
  );

  return { enabled, org_id, query_enabled };
};
